<template>
    <div :class="{ app__cart: !isPopup, popup__wrapper: isPopup }">
        <div class="app__cart-wrap" v-if="!isPopup">
            <button class="close-cart" @click="closeRightCart">
                <span></span><span></span>
            </button>
            <div class="mark-n-model">
                <div>
                    <div>
                        <p>
                            <span>Марка:</span
                            >{{
                                selectedMark ? selectedMark.mark : "Не выбрано"
                            }}
                        </p>
                        <button v-if="selectedMark" @click="removeModel(); removeMark(); goToStep(1);">
                            <span></span>
                        </button>
                    </div>
                    <div>
                        <p>
                            <span>Модель:</span
                            >{{
                                selectedModel
                                    ? selectedModel.model
                                    : "Не выбрано"
                            }}
                        </p>
<!--                        <button v-if="selectedModel" @click="removeModel">-->
<!--                            <span></span>-->
<!--                        </button>-->
                    </div>
                </div>
                <button @click="goToStep(1)">Изменить</button>
            </div>
            <el-table
                :data="selectedList"
                style="width: 100%"
                max-height="180"
                empty-text="Работы не выбраны"
            >
                <el-table-column prop="label" label="Вы выбрали" width="240">
                </el-table-column>
                <el-table-column
                    type="index"
                    label="Цена"
                    :index="workPriceToFixed"
                    width="80"
                >
                </el-table-column>
                <el-table-column width="20">
                    <template slot-scope="scope">
                        <el-button
                            icon="el-icon-circle-close"
                            class="delete-btn"
                            @click.native.prevent="deleteRow(scope)"
                            type="text"
                            size="small"
                        >
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="total-n-submit">
                <p><span>Итог:</span>{{ totalPrice ? totalPrice : 0 }} руб.</p>
                <button
                    class="btn"
                    :class="{ disable: !selectedList.length }"
                    @click.prevent="openCartPopup"
                >
                    Оформить заказ
                </button>
            </div>
        </div>
        <template v-else>
            <button class="close" @click="$emit('closeCartPopup')">
                <span></span><span></span>
            </button>
            <div v-if="selectedList.length">
                <PopupCart
                    :assets_url="assets_url"
                    @goToStep="goToStep"
                    @closeCartPopup="$emit('closeCartPopup')"
                ></PopupCart>
            </div>
            <div class="empty-popup" v-else>
                <p>не нашли нужную услугу?</p>
                <p>Наши консультанты найдут все!</p>
                <button class="btn" @click="closeEmptyPopupAndScrollToForm">
                    Отправить запрос
                </button>
                <button class="btn link-to-app" @click="closeEmptyPopup">
                    Индивидуальный подбор
                </button>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        assets_url: { type: String },
        isPopup: {
            type: Boolean,
        },
    },
    data: () => ({}),
    methods: {
        removeMark() {
            this.$store.dispatch("updateStateValue", {
                target: "manufactorer",
                value: "",
            });
        },
        removeModel() {
            this.$store.dispatch("updateStateValue", {
                target: "model",
                value: "key",
            });
        },
        closeRightCart() {
            this.$emit("closeRightCart");
        },
        goToStep(step) {
            this.$emit("goToStep", step);
        },
        deleteRow(row) {
            console.log(row);
            this.$store.dispatch("deleteSelectedWork", row);
        },
        workPriceToFixed(node) {
            return this.selectedList[node].workPrice.toFixed(1);
        },
        openCartPopup() {
            this.$store.dispatch("updateStateValue", {
                target: "cartPopupIsOpened",
                value: true,
            });

            document.querySelector("body").style.overflow = "hidden";
        },
        closeEmptyPopup() {
            this.goToStep(this.selectedEngine ? 3 : 1);
            this.$emit("closeCartPopup");
            $(".app")[0].scrollIntoView({ block: "start" });
        },
        closeEmptyPopupAndScrollToForm() {
            this.$emit("closeCartPopup");
            $(".request")[0].scrollIntoView({ block: "start" });
        },
        setWorks() {
            this.selectedList;
        },
    },
    computed: {
        /**
         * ID выбранной марки
         */
        selectedMark() {
            return this.$store.getters["getValue"]("manufactorer");
        },
        /**
         * Отслеживание модели авто
         */
        selectedModel() {
            return this.$store.getters["getValue"]("model");
        },
        selectedEngine() {
            return this.$store.getters["getValue"]("engine");
        },
        /**
         * Отслеживание модели авто
         */
        selectedList() {
            return this.$store.getters.getBothSelectedWorks;
        },
        totalPrice() {
            return this.$store.getters.cartPrice;
        },
        selectedXlsxWorks() {
            return this.$store.getters["getValue"]("selectedExlsWorks");
        },
    },
};
</script>